module.exports = __webpack_public_path__ + "img/fore_feature_1.411ef769.png";